import { Collection } from "backbone";
/* eslint-disable
    func-names,
    no-multi-assign,
    no-return-assign,
    no-shadow,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let CommentsRecommends;
export default CommentsRecommends = (function () {
  CommentsRecommends = class CommentsRecommends extends Collection {
    static initClass() {
      this.prototype.url = "/comments/recommends";
    }

    initialize(models, options) {
      return { content_id: this.content_id } = options != null;
    }
  };
  CommentsRecommends.initClass();
  return CommentsRecommends;
}());
